import { FormSuccess } from '../../../components/FormSuccess'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'

export default function AceleraMagentaCompletePage() {
  return (
    <PublicFormLayout title="Acelera Magenta">
      <FormSuccess
        title="Acelera Magenta Concluído!"
        description="Obrigado por participar do Acelera Magenta!"
        actions={[
          { label: 'Retornar para página inicial', to: '/acelera-magenta', loggedOnly: true },
          { label: 'Realizar um novo Acelera Magenta', to: '/acelera-magenta/new' }
        ]}
      />
    </PublicFormLayout>
  )
}
